export class AppConfig {
  /** URL base App */
  public static urlBase = '/v1';
  /** URL to test if the current user is logged into IAM and have permissions to access the API */
  public static urlPing = AppConfig.urlBase + '/ping';
  /** URL to get all templates data */
  public static urlTemplates = AppConfig.urlBase + '/templates';
  /** URL to get all template's delivery paths data */
  public static urlTemplateDeliveryPaths = AppConfig.urlBase + '/delivery-paths';
  /** URL to get all template's product lines data */
  public static urlTemplateProductLines = AppConfig.urlBase + '/product-lines';
  /** URL to get all template's component types data */
  public static urlTemplateComponentTypes = AppConfig.urlBase + '/component-type';
  /** URL to get the data of all contents of component by template name, delivery path and location */
  public static urlTempCompContsByTempNameDelPathLoc = AppConfig.urlBase +
    '/templates/{template_name}/components/{delivery_path}/contents/{locale}';
  /** URL to get the data of all contents of component by template name, delivery path, location and product*/
  public static urlTempCompContsByTempNameDelPathLocProg = AppConfig.urlBase +
    '/templates/{template_name}/components/{delivery_path}/contents/{locale}/products/{product_id}';
  /** URL to get the data of a component by id */
  public static urlTempCompById = AppConfig.urlBase + '/components/{template_component_id}';
  /** URL to get all Operators */
  public static urlOperators = AppConfig.urlBase + '/operators';
  /** URL to get all pairs of Operator-Programs */
  public static urlPrograms = AppConfig.urlBase + '/programs';
  /** URL to get all pairs of Program-Products */
  public static urlProducts = AppConfig.urlBase + '/products';
  /** URL to export Template-Priority */
  public static urlTemplatePriorityExport = AppConfig.urlBase + '/priority/export';
  /** URL to get all template's component variables */
  public static urlTemplateComponentVariables = AppConfig.urlBase + '/template-component-variables';
  /** URL to GET or DELETE a template component content by ID */
  public static urlTempCompContsById = AppConfig.urlBase + '/contents/{template_component_content_id}';
  /** URL to POST a template component content data */
  public static urlTempCompConts = AppConfig.urlBase + '/contents';
  /** URL to GET a template component content data by component and locale */
  public static urlTempCompContsByCompLoc = AppConfig.urlBase + '/components/{template_component_id}/contents/{locale}';
  /** URL to get the data of all contents of component by template name, delivery path, location and product*/
  public static urlCompsContsByLocProg = AppConfig.urlBase +
    '/components-contents/locale/{locale}/product/{product_id}';
  /** URL to GET a template component content data by component and locale */
  public static urlAuditBulkEditTCC = AppConfig.urlBase + '/audit-bulk-edit';
  /** URL to POST Text To Speech */
  public static urlTTS = AppConfig.urlBase + '/tts';
  /** URL to POST list voices and locales */
  public static urlPollyVoices = AppConfig.urlBase + '/polly/describeVoices';
  /** URL to GET list of TTS locale mappings xcore -> aws polly */
  public static urlTtsLocaleMappers = AppConfig.urlBase + '/mapper/aws_locale';
  /** URL to GET list of TTS locale mappings xcore -> aws polly */
  public static urlTtsXcoreLocales = AppConfig.urlBase + '/mapper/aws_locale/polly-to-xcore';
  /** URL to GET list of TTS locale mappings xcore -> aws polly */
  public static urlTtsPollyLocale = AppConfig.urlBase + '/mapper/aws_locale/xcore-to-polly';
  /** URL to GET list of TTS locale mappings xcore -> aws polly */
  public static urlTtsApplicationDefaultsByXcoreLocaleAndApplication =
    AppConfig.urlBase + '/tts_application_defaults/locale/{xcore_locale}/application_name/{tts_application_name}';
  /** URL to get User Details */
  public static urlUserDetails = AppConfig.urlBase + '/users/details';
  /** URL to get User Menu */
  public static urlUserMenu = AppConfig.urlBase + '/users/{user_id}/menu';
  /** URL to get User Organizations */
  public static urlUserOrganizations = AppConfig.urlBase + '/users/{user_id}/organizations';

  /** URL base Reference Data */
  public static urlBaseRefData = '/v3';
  /** URL to get all Locales */
  public static urlLocales = AppConfig.urlBaseRefData + '/locales';

  /** URL base Info-Push Service */
  public static urlBaseInfoPush = '/v1';
  /** URL to request for notification preview */
  public static urlPreviewInfoPush = AppConfig.urlBaseInfoPush + '/preview';

  /** URL to Priority */
  public static urlPriorities = AppConfig.urlBase + '/priorities';
  public static urlPrioritiesBulk = AppConfig.urlBase + '/priorities/bulk';
  public static urlPriority = AppConfig.urlBase + '/priority';

  /** URL to Events */
  public static urlEvents = AppConfig.urlBase + '/event_types';
   /** URL to template names */
  public static urlTemplateNames = AppConfig.urlBase + '/template_names';
  /** Timeout in ms for each request in HTTP Interceptor **/
  public static requestTimeout = 15 * 1000;
  /** Retry count for HttpErrors in HTTP Interceptor **/
  public static retryCountHttpRequestError = 3;
  /** Retry delay in msec that will be scaled in every attempt **/
  public static retryScalingDelayMs = 300;
  /** Session token variable name in the cookie **/
  public static sessionTokenVariableName = 'enoc_session';
  public static sessionUsernameVariableName = 'user_name';
  /** TTS Config */
  public static ttsSourceApp = 'XCore-ContentLibrary';

  public static readonly brandList = [
    { label: 'Consumers Energy', value: 'CONSUMERSENERGY' },
    { label: 'Enel X', value: 'ENELX' }
  ] as const;

}
